import React, { useState, useEffect } from "react";
import FeatureTabHeader from "../components/home/FeatureTabHeader";
import ManageBooking from "./ManageBooking";
import { useSelector } from "react-redux";
import EnhanceSailing from "./EnhanceSailing";
import UpgradeStateroom from "./UpgradeStateroom";
import HomeBanner from "../components/home/HomeBanner";
import Loader from "../components/Loader";
import { useLocation } from "react-router-dom";

const Home = () => {
  const [currentTab, setCurrentTab] = useState("View Reservations");
  const bookingDetails = useSelector((state) => state.bookingValidation.data);
  const isLoading = useSelector((state) => state.bookingValidation.isLoading);

  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tab = urlParams.get("currentTab");
    if (tab) {
      setCurrentTab(tab);
    }
  }, [location]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  , [currentTab]);

  return (
    <div>
      <HomeBanner bookingDetails={bookingDetails} currentTab={currentTab} />
      <div>
        <FeatureTabHeader
          cruise_id={bookingDetails?.cruise_id}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
        />
      </div>
      {currentTab === "View Reservations" && (
        <ManageBooking bookingDetails={bookingDetails} />
      )}
      {currentTab === "Enhance Sailing" && (
        <EnhanceSailing bookingDetails={bookingDetails} />
      )}
      {currentTab === "Upgrade Staterooms" && (
        <UpgradeStateroom bookingDetails={bookingDetails} />
      )}
      <Loader isLoading={isLoading} />
    </div>
  );
};

export default Home;
